import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const educationInfoForm = (props) => {
  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
        Some things about your education background and current work profile.
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="qualification"
            config={props.inputs.qualification}
            changed={event => props.inputChangedHandler(event, 'qualification')}
            loadOptions={() => asyncSelectData.getOptionConstants('qualification')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="profession"
            config={props.inputs.profession}
            changed={event => props.inputChangedHandler(event, 'profession')}
            loadOptions={() => asyncSelectData.getOptionConstants('profession')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="degree"
            config={props.inputs.degree}
            changed={event => props.inputChangedHandler(event, 'degree')}
            loadOptions={asyncSelectData.getDegrees}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="about_education"
            config={props.inputs.about_education}
            changed={event => props.inputChangedHandler(event, 'about_education')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="work_profile"
            config={props.inputs.work_profile}
            changed={event => props.inputChangedHandler(event, 'work_profile')}
            loadOptions={asyncSelectData.getWorkProfile}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="income"
            config={props.inputs.income}
            changed={event => props.inputChangedHandler(event, 'income')}
            loadOptions={asyncSelectData.getIncome}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="about_career"
            config={props.inputs.about_career}
            changed={event => props.inputChangedHandler(event, 'about_career')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default educationInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/EducationInfoForm.js